import { Directive, TemplateRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[buttonToggleItem]'
})
export class ButtonToggleItemDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
